import { apiRequest } from '@/lib/apiClient';
import type { AppInfo } from '@/types';

export const getAppInfo = () => apiRequest<AppInfo>('/api/app/info', { auth: false });

export const updateDepartment = (department: string) =>
  apiRequest<AppInfo>('/api/app/settings', { method: 'PUT', body: { department } });
